
import { Client } from '@stomp/stompjs';

class WebSocket {
    constructor(brokerURL, onConnect) {
        this.isConnected = false
        this.client = new Client({ brokerURL, onConnect })
    }

    subscribe = (path, subscribeCallback) => {
        if (this.client) {
            this.client.onConnect = () => {
                this.client.subscribe(path, subscribeCallback)
            }
        }
    }
    
    connect = () => {
        if (!this.isConnected && this.client) {
            this.client.activate()
            this.isConnected = true;
        }
    }
}

export default WebSocket;